import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';
import { LoadingSpinner } from '../components/loading/LoadingState';
import { useApi } from '../hooks/useApi';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
}) => {
  const location = useLocation();

  const {
    data: user,
    isLoading,
  } = useApi(
    async () => {
      try {
        const currentUser = await getCurrentUser();
        const attributes = await fetchUserAttributes();
        return {
          ...currentUser,
          attributes,
          groups: attributes['custom:groups']?.split(',') || []
        };
      } catch (error) {
        return null;
      }
    },
    {
      onError: (error) => {
        console.error('Error checking authentication:', error);
      },
    }
  );

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <LoadingSpinner />
      </div>
    );
  }

  if (!user) {
    // Redirect to login with return URL
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  if (requiredRole && !user.groups.includes(requiredRole)) {
    // Redirect to home if user doesn't have required role
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;